<template>
	<div class="wrapper">
		<div id="AccountScreen">
			<h2 id="AccountScreen__Title">
				Account Information
			</h2>
			<AccountEdit id="AccountScreen__Form"/>
		</div>
	</div>
</template>

<script>
	import { mapActions, mapState } from "vuex";
	import AccountEdit from "@/components/account/AccountEdit";

	export default {
		name: "Account",
		components: { AccountEdit },
		
	}
</script>

<style style lang="less" scoped>
@import "../../assets/components/account/Account.less";
</style>